import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, SearchIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { mainNav } from '../../data/navigation';
import { SearchBox } from './SearchBox';
import { MobileMenu } from './MobileMenu';
const ease = [0.23, 1, 0.32, 1] as const;
export function Header() {
  const {
    count,
    open
  } = useCart();
  const {
    pathname
  } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => setSearchOpen(false), [pathname]);
  const overlay = pathname === '/' && !scrolled && !searchOpen;
  const navItems = mainNav.filter(n => n.to !== '/collectie/alles');
  return <>
      <header className={`fixed inset-x-0 top-0 z-40 border-b transition-[background-color,border-color,color] duration-200 ${overlay ? 'border-transparent bg-transparent text-white' : 'border-line bg-canvas/90 text-ink backdrop-blur-md'}`} data-id="element-198" data-mp="bsx8s5fkrl9t">
        <div className="mx-auto grid h-16 max-w-7xl grid-cols-[1fr_auto_1fr] items-center px-5 lg:h-[4.5rem] lg:px-8" data-id="element-199" data-mp="3k3ia6l04k1qf">
          <div className="flex items-center" data-id="element-200" data-mp="3p1juf99ae73h">
            <button type="button" onClick={() => setMenuOpen(true)} className="-ml-2 grid h-10 w-10 place-items-center rounded-full lg:hidden" aria-label="Menu openen" data-id="element-201" data-mp="3tzv3hhrrcdkn">
              <MenuIcon className="h-5 w-5" data-id="element-202" data-mp="199m6po1em3dx" />
            </button>
            <nav aria-label="Shop" className="hidden lg:block" data-id="element-203" data-mp="1db7nvlkz13tx">
              <ul className="flex items-center gap-7" data-id="element-204" data-mp="1ddllo271cu56">
                {navItems.map(item => <li key={item.to} data-id="element-205" data-mp="3ae7y8wz6c23h">
                    <NavLink to={item.to} className={({
                  isActive
                }) => `whitespace-nowrap text-sm font-medium transition-opacity duration-150 ${isActive ? 'opacity-100' : 'opacity-75 hover:opacity-100'}`} data-id="element-206" data-mp="35e3carfhyf5v">
                      {item.label}
                    </NavLink>
                  </li>)}
              </ul>
            </nav>
          </div>

          <Link to="/" className="text-xl font-semibold tracking-[0.32em] lg:text-2xl" aria-label="AMIRA, naar home" data-id="element-207" data-mp="30e7bt260d5v2">
            AMIRA
          </Link>

          <div className="flex items-center justify-end gap-1 sm:gap-2" data-id="element-208" data-mp="2vlxozv06wlx0">
            <Link to="/collectie/alles" className="hidden whitespace-nowrap px-3 text-sm font-medium opacity-75 transition-opacity duration-150 hover:opacity-100 xl:block" data-id="element-209" data-mp="27x4r3t00c3zr">
              Shop alles
            </Link>
            <button type="button" onClick={() => setSearchOpen(s => !s)} className="grid h-10 w-10 place-items-center rounded-full" aria-label={searchOpen ? 'Zoeken sluiten' : 'Zoeken'} aria-expanded={searchOpen} data-id="element-210" data-mp="ifze83f0b4z6">
              {searchOpen ? <XIcon className="h-5 w-5" data-id="element-211" data-mp="effgoyqitzci" /> : <SearchIcon className="h-5 w-5" data-id="element-212" data-mp="124rxajo6h9ou" />}
            </button>
            <button type="button" onClick={open} className={`flex h-10 items-center gap-2 rounded-full pl-3.5 pr-1.5 text-sm font-medium transition-colors duration-150 ${overlay ? 'bg-white text-ink hover:bg-canvas' : 'bg-ink text-canvas hover:bg-clay'}`} aria-label={`Winkelwagen, ${count} artikelen`} data-id="element-213" data-mp="125jhkycbrkzt">
              <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-214" data-mp="3cyw52k4yh50x" />
              <span className={`grid h-7 min-w-7 place-items-center rounded-full px-1.5 text-xs font-semibold tabular-nums ${overlay ? 'bg-ink text-white' : 'bg-canvas text-ink'}`} data-id="element-215" data-mp="3hwp7r371vgwg">
                {count}
              </span>
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-216" data-mp="3oav612pdpsui">
          {searchOpen && <motion.div initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.18,
          ease
        }} className="border-t border-line bg-canvas" data-id="element-217" data-mp="3jffpg2zzliue">
              <div className="mx-auto max-w-2xl px-5 py-4" data-id="element-218" data-mp="axjjp6cbui9o">
                <SearchBox autoFocus onNavigate={() => setSearchOpen(false)} data-id="element-219" data-mp="5z8cz4hbwnvo" />
              </div>
            </motion.div>}
        </AnimatePresence>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-220" data-mp="2vpv8tqrb2xoa" />
    </>;
}